<script>
import { mapGetters } from 'vuex'
import LocationResource from '../resources/location'

export default {
    name: 'WelcomeScreen',
    components: {},
    computed: {
        ...mapGetters(['userResource'])
    },
    props: {},
    data() {
        return {
            loading: true,
            locationResources: [],
            selectedLocation: null,
            includeBoards: true
        }
    },
    watch: {},
    methods: {
        async onSubmit() {
            this.$router.push({ name: 'menu', query: { location: this.selectedLocation.id, boards: this.includeBoards } })
        },
    },
    async mounted() {
        document.documentElement.setAttribute('data-theme', 'dark')
        this.locationResources = await LocationResource.all()
        this.selectedLocation = this.locationResources.find((location) => location.id == this.userResource.attributes.location)
        this.loading = false
    },
}
</script>

<template>
    <div class="display-unit" v-if="!loading">
        <b-container class="starting-form">
            <b-row>
                <b-col md="4" offset-md="4">
                    <form @submit.prevent="onSubmit">
                        <b-form-group label="Location">
                            <b-form-select v-model="selectedLocation">
                                <b-form-select-option v-for="(locationResource, i) in locationResources" :key="i" :value="locationResource">{{ locationResource }}</b-form-select-option>
                            </b-form-select>
                        </b-form-group>
                        <b-form-group label="Include Boards?">
                            <b-form-select v-model="includeBoards">
                                <b-form-select-option :value="true">Yes</b-form-select-option>
                                <b-form-select-option :value="false">No</b-form-select-option>
                            </b-form-select>
                        </b-form-group>
                        <b-button type="submit" class="col-12" variant="light">Show Menu</b-button>
                    </form>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<style lang="scss" scoped>
.display-unit {
    min-height: 100vh;
    color: var(--sos-display-ink);
    font-family: var(--sos-font);
    background: linear-gradient(180deg, var(--sos-display-bg-2), var(--sos-display-bg));

    .starting-form {
        margin-top: 18vh;

        ::v-deep label {
            font-family: var(--sos-font-head);
            font-weight: 700;
            letter-spacing: 0.04em;
            color: rgba(255, 255, 255, 0.75);
        }

        ::v-deep .form-control,
        ::v-deep .custom-select {
            background: rgba(255, 255, 255, 0.08);
            border-color: rgba(255, 255, 255, 0.16);
            color: #fff;
            border-radius: var(--sos-r-sm);
        }

        ::v-deep .btn {
            font-family: var(--sos-font-head);
            font-weight: 700;
        }
    }
}
</style>
